<template>
  <div class="container">
    <vue-headful
      title="Contact | Rhys Matthew | Web Developer"
      description="Need help on a project? Let's arrange a call to discuss your project. Whether it's Web Design, Front-End Development or a CMS integrated website, get in touch to find out more."
      keywords="Contact Rhys Matthew, Web Developer, Get in touch, Email Rhys Matthew, UI Developer, UX Design, Web design, Front-End Development, JavaScript dev, Contact Developer, Web Engineer, CSS, PHP, Rhys Matthew Web Developer, Wordpress Developer, Freelance"
      :head="{
        'meta[property=\'og:url\']': {content: 'https://rhys.digital/contact/'},
        'meta[name=\'twitter:site\']': {content: 'https://rhys.digital/contact/'},
        'link[rel=\'canonical\']': {href: 'https://rhys.digital/contact/'}
      }"
    />

    <PageHeader></PageHeader>

    <section class="section">
      <div class="mw--800">
        <div class="section__block">

          <prismic-rich-text :field="fields.contactIntro"/>
          <p>
            <strong class="pr-1">Email:</strong> <a href="javascript:antiSpamMail.linkDecrypt('nbjmup;dpoubduAsizt/ejhjubm');" class="btn"><span class="btn__inner">contact<span class="crypt" aria-hidden="true">.</span>@<span class="crypt" aria-hidden="true">.</span>rhys<span class="crypt" aria-hidden="true">.</span>.<span class="crypt" aria-hidden="true">.</span>digital</span></a>
          </p>

          <br>

          <div class="contact-divider">
            <p tabindex="0"><strong>Alternatively, use the form below</strong></p>
          </div>

          <ContactForm></ContactForm>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// Page header
import PageHeader from '../components/page-header/PageHeader'

// Contact form
import ContactForm from '../components/forms/ContactForm'

export default {
  data: function () {
    return {
      fields: {
        contactIntro: []
      }
    }
  },
  components: {
    PageHeader,
    ContactForm
  },
  created () {
    // Get page content
    this.getContactContent()
  },
  mounted () {
    // eslint-disable-next-line
    setTimeout (() => {
      // Dispatch pageLoad event
      //
      const pageLoad = new CustomEvent('pageLoad')
      document.dispatchEvent(pageLoad)
    }, 250)
  },
  updated () {
    // eslint-disable-next-line
    setTimeout (() => {
      // Dispatch pageLoad event
      //
      const pageLoad = new CustomEvent('pageLoad')
      document.dispatchEvent(pageLoad)
    }, 250)
  },
  methods: {
    getContactContent: function () {
      this.$prismic.client.getSingle('contact')
        .then((response) => {
          this.fields.contactIntro = response.data.contact_intro
        })
    }
  }
}
</script>

<style lang="scss">
// ==============================
// Contact divider
// ========================================

.contact-divider {
  width: 100%;
  margin-top: 40px;
  margin-bottom: 40px;
  text-align: center;
  border-bottom: 1px solid $color-grey;
}
</style>
